import React, { useMemo } from 'react';
import { shallowEqual } from 'react-redux';
import { rtDebug } from '..';
import { useAppSelector } from '../../../../../hooks/hooks';
import useRenderDebug from '../../../../../hooks/useRenderDebug';
import useDomProps from '../../../../../store/selection/useDomProps';
import Header from '../Header';
import { useResponsiveTableContext } from '../ResponsiveTableContext';
import Row from '../Row';
import NoRegistersRenderer from './NoRegistersRenderer';

const TableRenderer = () => {
  const { name, label, variants } = useResponsiveTableContext();
  const domProps = useDomProps(
    'table',
    {},
    (global) => global.responsiveTableSlice[name],
  );

  const rows = useAppSelector((global) => {
    const tableState = global.responsiveTableSlice[name];
    return (tableState?.rows ?? []).map((current) => current.id);
  }, shallowEqual);

  const { columnsCount, rowsCount } = useAppSelector((global) => {
    const tableState = global.responsiveTableSlice[name];
    return {
      rowsCount: tableState?.rows.length ?? 0,
      columnsCount:
        (tableState?.nonAdditionalColumnsCount ?? 0) +
        (tableState?.hasNonAdditionalFilters ? 1 : 0) +
        (tableState?.statesColumns.length ?? 0),
    };
  }, shallowEqual);

  useRenderDebug(rtDebug.tableRenderer, 'TableRenderer.tsx', {
    rows,
    domProps,
    name,
  });

  return (
    <table
      {...domProps}
      className="responsiveTable__table"
      aria-label={label}
      {...window.getVariant(variants?.table ?? 'layout.common.tables.primary')}
      sx={useMemo(
        () => ({ variant: variants?.table ?? 'layout.common.tables.primary' }),
        [variants?.table],
      )}
    >
      <Header />
      <tbody>
        {rowsCount > 0 ? (
          rows.map((row, index) => {
            return (
              <Row key={row ?? `${row as string}-${index}`} rowIndex={index} />
            );
          })
        ) : (
          <tr>
            <td colSpan={columnsCount}>
              <NoRegistersRenderer />
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default React.memo(TableRenderer);
